import { render, staticRenderFns } from "./AgriculturalRestrictions.vue?vue&type=template&id=49fa672a"
import script from "./AgriculturalRestrictions.vue?vue&type=script&lang=js"
export * from "./AgriculturalRestrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports